export default __webpack_public_path__ + "static/media/include_9_male@2x.519307b6.jpg";